/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rollback_BtnInputs */

const vi_note_rollback_btn = /** @type {(inputs: Note_Rollback_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollback`)
};

/**

* @param {Note_Rollback_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_btn = /** @type {((inputs?: Note_Rollback_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_btn(inputs)
});